export const formatHeight = (h) => {
  if (!h) return null;
  if (typeof h === "string" && h.includes("-")) return h;
  if (typeof h === "number") return `${Math.floor(h / 12)}'${h % 12}"`;
  return h;
};

export const formatHand = (hand) => {
  if (!hand) return "—";
  return typeof hand === 'string' ? hand.toUpperCase() : hand;
};

export const formatPlayerInfo = (stats) => {
  const height = formatHeight(stats?.height);
  const playerClass = stats?.class ? `Class: ${stats.class}` : null;
  return [height, playerClass].filter(Boolean);
};


